export const PROJECT_STATUSES = [
  "propuesto",
  "aprobado",
  "en_ejecucion",
  "pausado",
  "en_revision",
  "cerrado",
  "cancelado",
];

export const TASK_STATUSES = [
  "pendiente",
  "en_progreso",
  "bloqueada",
  "completada",
  "cancelada",
];

export const TASK_TYPES = ["actividad", "etapa", "hito"];

export const PARTICIPANT_RESPONSIBILITIES = [
  "Responsable del proyecto",
  "Coordinador tecnico",
  "Ejecutor tecnico",
  "Supervisor",
  "Validador / aprobador",
  "Observador",
];

export const EQUIPMENT_FUNCTIONS = [
  "medicion",
  "monitoreo",
  "control",
  "validacion",
  "reemplazo",
  "soporte",
  "otro",
];

export const DEVICE_TYPES = [
  "medidor",
  "sensor",
  "controlador",
  "gateway",
  "equipo",
  "otro",
];

export const formatStatusLabel = (status) => {
  if (!status) return "-";
  return String(status).replace(/_/g, " ");
};

export const formatDate = (value) => {
  if (!value) return "-";
  const calendarDate = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
  if (calendarDate) {
    const [, year, month, day] = calendarDate;
    return `${Number(day)}/${Number(month)}/${year}`;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("es-AR");
};

export const formatCurrency = (value) => {
  if (value == null || value === "") return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return "-";
  return num.toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatProgress = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return 0;
  return Math.min(100, Math.max(0, num));
};

export const toDateInputValue = (value) => {
  if (!value) return "";
  return String(value).slice(0, 10);
};

export const toNullableNumber = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

export const toSelectOptions = (baseOptions, values = []) => {
  const seen = new Set();
  return [...baseOptions, ...values]
    .map((value) => (value == null ? "" : String(value).trim()))
    .filter(Boolean)
    .filter((value) => {
      const key = value.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

export const getUserLabel = (user) => {
  if (!user) return "Usuario";
  return (
    user.user ||
    user.name ||
    user.mail ||
    `Usuario ${user.id_user || user.id || ""}`.trim()
  );
};

export const getDeviceLabel = (device) => {
  if (!device) return "Equipo";
  const name = device.name || device.device_name || "Equipo";
  const serial = device.serial_number || device.mac;
  return serial ? `${name} (${serial})` : name;
};

export const getBranchId = (branch) =>
  branch?.id_branch_offices ?? branch?.branch_id ?? branch?.id_company ?? branch?.id;

export const getBranchLabel = (branch) =>
  branch?.office_name ||
  branch?.name ||
  branch?.company_name ||
  `Sucursal ${getBranchId(branch) || ""}`.trim();

export const getCompanyId = (company) =>
  company?.id_company ?? company?.company_id ?? company?.id;

export const getCompanyLabel = (company) =>
  company?.company_name ||
  company?.name ||
  company?.office_name ||
  `Compania ${getCompanyId(company) || ""}`.trim();

export const getScopeFromProjectForm = (form = {}) => ({
  company_fk: form.company_id ? Number(form.company_id) : null,
  branch_fk: form.branch_id ? Number(form.branch_id) : null,
  place_fk: null,
  zone_fk: null,
  local_fk: null,
});

export const deviceMatchesScope = (device = {}, scope = {}) => {
  if (!scope.company_fk || !scope.branch_fk) return false;
  if (Number(device.company_fk) !== Number(scope.company_fk)) return false;

  const fields = ["branch_fk", "place_fk", "zone_fk", "local_fk"];
  const hasPlantScope = fields.some((field) => device[field] != null && device[field] !== "");
  if (!hasPlantScope) return false;

  return Number(device.branch_fk) === Number(scope.branch_fk);
};

export const canManageProjects = (privilege) =>
  ["admin", "master", "technical", "manager", "admin-master"].includes(
    String(privilege || "").toLowerCase(),
  );
